import type { ToastSeverity } from '@/context/ToastContext';

const DEFAULT_DURATION_MS = 2600;
// Error toasts carry a full sentence the user has to actually read and act
// on, not just a brief confirmation — give them more time on screen.
const ERROR_DURATION_MS = 5000;

/** Picks how long a toast stays visible when the caller didn't request a specific duration. */
export function resolveToastDuration(
  severity: ToastSeverity,
  durationMs?: number,
): number {
  if (durationMs !== undefined) return durationMs;
  return severity === 'error' ? ERROR_DURATION_MS : DEFAULT_DURATION_MS;
}
